import Vue from 'vue';
import Vuex from 'vuex';

import Product from '@/models/Product';
import GroupManager from '@/models/GroupManager';

import SpecialRoom from '@/models/Room/SpecialRoom';
import Team from '@/models/Room/Team';

import {
  PRODUCT_COUNT,
  TICK_INTERVAL,
  TYPE_PRODUCT,
  TYPE_TEAMS,
} from '@/constants';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tick: 0,
    tickInterval: undefined,
    groupManager: new GroupManager(),
    teamTypeToCreate: '',
  },
  actions: {
    setProduct({ commit }) {
      for (let i = 0; i < PRODUCT_COUNT; i += 1) {
        commit('addProduct', new Product());
      }
    },
  },
  mutations: {
    startTickInterval(state) {
      state.teamTypeToCreate = '';
      state.tickInterval = setInterval(() => {
        state.tick += 1;
        state.groupManager.processByTick();
      }, TICK_INTERVAL);
    },
    clearTickInterval(state) {
      window.clearInterval(state.tickInterval);
      state.tickInterval = undefined;
    },
    addProduct(state, product) {
      state.groupManager.addGroup(product);
    },
    addStory(state, product) {
      product.addStory();
    },
    addRoom(state, roomConfig) {
      let TypeClass = Team;
      if (roomConfig.type === TYPE_TEAMS.PANTRY || roomConfig.type === TYPE_TEAMS.MEETING) {
        TypeClass = SpecialRoom;
      }
      state.groupManager.addGroup(new TypeClass({
        ...roomConfig,
        groupManager: state.groupManager,
      }));
    },
    selectTeamTypeToCreate(state, teamType) {
      state.teamTypeToCreate = teamType;
    },
  },
  getters: {
    allEmployeeCount: (state) => state.groupManager.groupList
      .filter((group) => group.type !== TYPE_PRODUCT)
      .reduce((acc, team) => team.memberCount + acc, 0),
    employees: (state) => state.groupManager.groupList
      .filter((group) => group.type !== TYPE_PRODUCT)
      .reduce((acc, team) => [...acc, ...team.memberList], [])
      .filter((member) => member),
    packets: (state) => state.groupManager.pathManager.packetList,
    products: (state) => state.groupManager.groupList
      .filter((group) => group.type === TYPE_PRODUCT),
    teams: (state) => state.groupManager.groupList
      .filter((group) => group.type !== TYPE_PRODUCT),
  },
});
